module.exports = __webpack_public_path__ + "img/check-calendar.3dfd1804.svg";